<button (click)="onNoClick()" class="printPageButton">close</button>
<button (click)="onp()" class="printPageButton">
  PDF
</button>

<div class="saltopagina" *ngIf="hoja1v">
  <div
    id="printableArea"
    class="saltopagina"
    style="font-family: Arial !important;transform: scale(1) !important;   display: block;page-break-before: always;"
    #pdfTable
  >
    <div
      class="printPageButton"
      style="font-family: Arial !important;-aw-headerfooter-type:header-primary; clear:both"
      *ngIf="false"
    >
      <ol
        start="2"
        type="I"
        style="font-family: Arial !important;margin:0pt; padding-left:0pt"
      >
        <li
          style="font-family: Arial !important;margin-left:14.45pt; text-align:justify; line-height:14.5pt; font-family:Arial; font-size:13pt"
        >
          <span
            style="font-family: Arial !important;font-weight:bold; color:black"
            >The Standard Bill of Lading Form</span
          >
        </li>
      </ol>
    </div>
    <p
      class="printPageButton"
      style="font-family: Arial !important;margin-top:4pt; text-align:justify; line-height:10.05pt"
      *ngIf="false"
    >
      <span
        style="font-family: Arial !important;font-family:Arial; font-size:9pt; color:black"
        >GS1 US (VICS) Standard BOL:</span
      ><span
        style="font-family: Arial !important;font-family:Arial; font-size:9pt; color:black; -aw-import:spaces"
        >&#xa0; </span
      ><span
        style="font-family: Arial !important;font-family:Arial; font-size:9pt; color:black"
        >http://www.gs1us.org/, then click Logistics for complete BOL guideline
        information.</span
      >
    </p>
    <p
      *ngIf="false"
      class="printPageButton"
      style="font-family: Arial !important;margin-top:9.4pt; text-align:justify; font-size:1pt"
    >
      <span
        style="font-family: Arial !important;font-family:Arial; color:#ffffff; background-color:#ffffff; -aw-import:spaces"
        >&#xa0;</span
      >
    </p>

    <table
      class="tableW"
      style="font-family: Arial !important;-aw-border-insideh:0.5pt single #000000;-aw-border-insidev:0.5pt single #000000; border-collapse:collapse;padding: 100px;transform-origin: left;"
    >
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          style="font-family: Arial !important;height:20.25pt; -aw-height-rule:exactly;background-color: white !important;"
        >
          <td
            colspan="9"
            style="font-family: Arial !important;font-weight: bold !important;border:0.75pt solid black; vertical-align:top; -aw-border:0.5pt single;color: white !important;"
          >
            <p
              style="font-family: Arial !important;font-size: 17px !important;text-align: center !important;color: black !important;background-color: white !important;"
            >
              BILL OF LADING Date: {{data.orderData.shipDate | date}} Page: 1
            </p>
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:69.3pt; -aw-height-rule:exactly"
        >
          <td
            rowspan="4"
            style="font-family: Arial !important;width:283.15pt; border:0.75pt solid black; vertical-align:top; -aw-border:0.5pt single"
          >
            <p
              *ngFor="let item of InfoCompany; let i=index"
              style="font-family: Arial !important;color: black !important;font-size: 17px !important;margin-top: -36px;text-align: center;"
            >
              <label
                style="font-family: Arial !important;font-weight: bold !important;background-color: white;color: black !important;margin-top: 35px;font-size: 17px !important;width: 400px;background: black;color: white !important;"
              >
                <b>SHIP FROM</b></label
              >
              <br />
              <b> Name:</b> {{item.Company_Name}} <br />

              <b>Address:</b> {{item.Address}} <br />

              <b>City/State/Zip:</b> {{item.City}} ,{{item.State}} {{item.Zip}}
              <br />
              <b>Phone:</b>{{item.Phone}} <br />

              <b> SID#:</b> <br />
              <label
                style="font-family: Arial !important;font-weight: bold !important;background-color: white;color: black !important;font-size: 17px !important;width: 400px;background: black;color: white !important;"
                ><b>SHIP TO</b></label
              >
              <br />
              <b>Name:</b> {{data.shipto.Company}} <br />

              <b>Address:</b> {{data.shipto.Address}} <br />

              <b>City/State/Zip:</b> {{data.shipto.City}} ,{{data.shipto.State}}
              {{data.shipto.Zip}} <br />
              <b>Phone:</b> {{data.shipto.Phone}} <br />

              <b>CID#:</b> <br />
              <label
                style="font-family: Arial !important;font-weight: bold !important;background-color: white;color: black !important;font-size: 17px !important;width: 400px;background: black;color: white !important;"
                ><b>THIRD-PARTY FREIGHT CHARGES BILL TO</b></label
              >
              <br />
              <b> Name:</b> {{data.billto.Company}} <br />

              <b> Address:</b> {{data.billto.Address}} <br />

              <b> City/State/Zip:</b> {{data.billto.City}}
              ,{{data.billto.State}} {{data.billto.Zip}} <br />
              <b> Phone:</b> {{data.billto.Phone}} <br />
            </p>
          </td>
          <td
            colspan="8"
            style="font-family: Arial !important;width:227.58pt; border:0.75pt solid black; padding-left:5.92pt; vertical-align:top; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;text-align: left;"
            >
              <b>Bill of Lading Number:</b>{{data.order}}
            </p>
            <ngx-barcode
              bc-width="2"
              bc-height="20"
              [bc-value]="data.order"
              [bc-display-value]="true"
              bc-format="CODE39"
              class="barcodes"
            >
            </ngx-barcode>
            <br />
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:44pt; -aw-height-rule:exactly"
        >
          <td
            colspan="8"
            style="font-family: Arial !important;width:227.58pt; border:0.75pt solid black; padding-left:5.92pt; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;text-align: left;"
            >
              <b>Carrier Name:</b> {{data.carrier.CarrierName}}
            </p>
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;text-align: left;"
            >
              <b>Trailer number:</b>{{data.carrier.Trailer}}
            </p>
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;text-align: left;"
            >
              <b>Seal number(s):</b> {{data.carrier.Sealnumber}}
            </p>
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:62.4pt; -aw-height-rule:exactly"
        >
          <td
            colspan="8"
            id="tdbaarcode"
            style="font-family: Arial !important;border: 0.75pt solid black;"
          >
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;text-align: left;"
            >
              <b>SCAC:</b>{{data.carrier.scac}}
            </p>
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;text-align: left;height: 2em !important;"
            >
              <b>Pro number:</b>
              <label
                *ngFor="let user of data.items; index as i; first as isFirst"
                style="font-family: Arial !important;width: 16em;font-size: 17px !important;"
              >
                <span *ngIf="isFirst">{{user.miscnumber}}</span>
              </label>
            </p>

            <div
              *ngFor="let user of data.items; index as i; first as isFirst"
              style="font-family: Arial !important;
            width: 25em !important;
        "
            >
              <ngx-barcode
                bc-height="120"
                [bc-value]="user.miscnumber"
                [bc-display-value]="true"
                bc-format="CODE39"
                class="barcodes"
                *ngIf="isFirst"
              >
              </ngx-barcode>
            </div>
            <br />
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:26.6pt; -aw-height-rule:exactly"
        >
          <td
            colspan="8"
            rowspan="1"
            style="font-family: Arial !important;width:207.45pt; border:0.75pt solid black; padding-right:19.58pt; padding-left:6.48pt; vertical-align:top; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;margin-top:4pt; line-height:11.9pt"
            >
              <span
              *ngIf="!isLDT"
                style="font-family: Arial !important;font-family:Arial; font-size:17px !important; color:black"
                >Freight Charge Terms: <br />
                (freight charges are prepaid unless marked otherwise) <br />
                Prepaid_______ Collect_______ 3rd Party______
              </span>
              <span
              *ngIf="isLDT"
                style="font-family: Arial !important;font-family:Arial; font-size:17px !important; color:black"
                >Freight Charge Terms: <br />
                (freight charges are prepaid unless marked otherwise) <br />
                Prepaid_______ Collect_<b>X</b>_ 3rd Party______
              </span>
            </p>
          </td>
        </tr>
        <tr style="font-family: Arial !important;-aw-height-rule:exactly">
          <td
            rowspan="2"
            style="font-family: Arial !important;width:90.95pt; border:0.75pt solid black; padding-left:4.42pt; vertical-align:top; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;margin-top: 3.3pt;text-align: justify;line-height: 11.8pt;color: black !important;font-size: 17px !important;height: 51px;"
            >
              <span
                style="font-family: Arial !important;font-family:Arial; font-size:17px !important; color:black;font-weight: bold !important;"
                ><b>SPECIAL INSTRUCTIONS:</b>
              </span>
              <br>
              {{data.orderData.comments}} <br />
              {{data.orderData.notes}}
            </p>
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:22.25pt; -aw-height-rule:exactly"
        >
          <td
            colspan="8"
            style="font-family: Arial !important;border-top:0.75pt solid black; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom:0.75pt solid black; padding-right:5.03pt; padding-left:5.03pt; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;text-indent:60.65pt; line-height:13pt"
            >
              <span
                style="font-family: Arial !important;font-family:Arial; font-size:17px !important; color:black"
                >Master Bill of Lading: with attached underlying [ ] (check box)
                Bills of Lading</span
              >
            </p>
          </td>
        </tr>
      </tbody>
      <tr
        style="font-family: Arial !important;height:10.3pt; -aw-height-rule:exactly;background-color: #000000 !important;"
      >
        <th
          colspan="12"
          style="font-weight: bold !important;font-family: Arial !important;color: white !important;font-weight: bold !important;"
        >
          CUSTOMER INFORMATION ORDER
        </th>
      </tr>
      <tr
        style="font-family: Arial !important;height:18.15pt; -aw-height-rule:exactly"
      >
        <td
          style="font-weight: bold !important;font-family: Arial !important;width:104.45pt; border:0.75pt solid black; padding-right:23.02pt; padding-left:26.32pt; vertical-align:top; -aw-border:0.5pt single"
        >
          CUSTOMER ORDER NUMBER
        </td>
        <td
          style="font-weight: bold !important;font-family: Arial !important;width:30.3pt; border:0.75pt solid black; padding-right:21.28pt; padding-left:22.98pt; vertical-align:top; -aw-border:0.5pt single"
        >
          #PLTS
        </td>
        <td
          style="font-weight: bold !important;font-family: Arial !important;width:33pt; border:0.75pt solid black; padding-right:16.68pt; padding-left:18.32pt; vertical-align:top; -aw-border:0.5pt single"
        >
          WEIGHT
        </td>
        <td
          colspan="2"
          style="font-family: Arial !important;width:47.65pt; border:0.75pt solid black; padding-right:8.88pt; padding-left:14.22pt; vertical-align:middle; -aw-border:0.5pt single"
        >
          <span
            style="font-weight: bold !important;font-family: Arial !important;font-family:Arial; font-size:17px !important; color:black"
            >PALLET/SLIP </span
          ><span
            style="font-weight: bold !important;font-family: Arial !important;font-family:Arial; font-size:17px !important; color:black"
            >(CIRCLE ONE)</span
          >
        </td>
        <td
          colspan="4"
          style="font-weight: bold !important;font-family: Arial !important;width:100.3pt; border:0.75pt solid black; padding-right:31.22pt; padding-left:36.67pt; vertical-align:top; -aw-border:0.5pt single"
        >
          ADDITIONAL SHIPPER INFO.
        </td>
      </tr>
      <tr
        style="font-family: Arial !important;height:18.3pt; -aw-height-rule:exactly"
      >
        <td
          style="font-family: Arial !important;width:153.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          {{data.order}}
        </td>
        <td
          style="font-family: Arial !important;width:74.55pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          {{data.items.length}}
        </td>
        <td
          style="font-family: Arial !important;width:68pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          {{sumaweight}}
        </td>
        <td
          style="font-family: Arial !important;width:9.65pt; border:0.75pt solid black; padding-right:10.07pt; padding-left:15.02pt; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;text-align:center; line-height:7.8pt"
          >
            <span
              style="font-weight: bold !important;font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
              >Y</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:10.1pt; border:0.75pt solid black; padding-right:10.02pt; padding-left:15.12pt; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;text-align:center; line-height:7.8pt"
          >
            <span
              style="font-weight: bold !important;font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
              >N</span
            >
          </p>
        </td>
        <td
          colspan="4"
          style="font-family: Arial !important;width:168.2pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
      </tr>
      <tr
        style="font-family: Arial !important;height:17.7pt; -aw-height-rule:exactly"
      >
        <td
          style="font-family: Arial !important;width:153.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:74.55pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:68pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:9.65pt; border:0.75pt solid black; padding-right:10.07pt; padding-left:15.02pt; vertical-align:top; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;margin-top:4.15pt; text-align:center; line-height:7.8pt"
          >
            <span
              style="font-weight: bold !important;font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
              >Y</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:10.1pt; border:0.75pt solid black; padding-right:10.02pt; padding-left:15.12pt; vertical-align:top; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;margin-top:4.15pt; text-align:center; line-height:7.8pt"
          >
            <span
              style="font-weight: bold !important;font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
              >N</span
            >
          </p>
        </td>
        <td
          colspan="4"
          style="font-family: Arial !important;width:168.2pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
      </tr>
      <tr
        style="font-family: Arial !important;height:18.3pt; -aw-height-rule:exactly"
      >
        <td
          style="font-family: Arial !important;width:153.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:74.55pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:68pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:9.65pt; border:0.75pt solid black; padding-right:10.07pt; padding-left:15.02pt; vertical-align:top; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;margin-top:4.1pt; text-align:center; line-height:7.8pt"
          >
            <span
              style="font-weight: bold !important;font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
              >Y</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:10.1pt; border:0.75pt solid black; padding-right:10.02pt; padding-left:15.12pt; vertical-align:top; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;margin-top:4.15pt; text-align:center; line-height:7.8pt"
          >
            <span
              style="font-weight: bold !important;font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
              >N</span
            >
          </p>
        </td>
        <td
          colspan="4"
          style="font-family: Arial !important;width:168.2pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
      </tr>
      <tr
        style="font-family: Arial !important;height:17.7pt; -aw-height-rule:exactly"
      >
        <td
          style="font-family: Arial !important;width:153.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:74.55pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:68pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:9.65pt; border:0.75pt solid black; padding-right:10.07pt; padding-left:15.02pt; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;text-align:center; line-height:7.8pt"
          >
            <span
              style="font-weight: bold !important;font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
              >Y</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:10.1pt; border:0.75pt solid black; padding-right:10.02pt; padding-left:15.12pt; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;text-align:center; line-height:7.8pt"
          >
            <span
              style="font-weight: bold !important;font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
              >N</span
            >
          </p>
        </td>
        <td
          colspan="4"
          style="font-family: Arial !important;width:168.2pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
      </tr>
      <tr
        style="font-family: Arial !important;height:18.3pt; -aw-height-rule:exactly"
      >
        <td
          style="font-weight: bold !important;font-family: Arial !important;width:54.2pt; border:0.75pt solid black; padding-right:95.18pt; padding-left:4.42pt; vertical-align:top; -aw-border:0.5pt single"
        >
          GRAND TOTAL
        </td>
        <td
          style="font-weight: bold !important;font-size: 17px !important;font-family: Arial !important;width:74.55pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          {{data.items.length}}
        </td>
        <td
          style="font-weight: bold !important;font-size: 17px !important;font-family: Arial !important;width:68pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          {{sumaweight}}
        </td>
        <td
          style="font-family: Arial !important;width:34.75pt; border-top:0.75pt solid black; border-right:0.75pt solid black; border-left:0.75pt solid black; border-bottom:0.75pt solid white !important; vertical-align:middle; background-color:white !important; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:35.25pt; border-top:0.75pt solid black; border-right:0.75pt solid black; border-left:0.75pt solid black; border-bottom:0.75pt solid white !important; vertical-align:middle; background-color:white !important; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td
          colspan="4"
          style="font-family: Arial !important;width:168.2pt; border-top:0.75pt solid black; border-right:0.75pt solid black; border-left:0.75pt solid black; border-bottom:0.75pt solid white !important; vertical-align:middle; background-color:white !important; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
      </tr>
    </table>
    <table class="tableW2">
      <thead>
        <tr
          style="font-family: Arial !important;height:10.3pt; -aw-height-rule:exactly;background-color: #000000 !important;"
        >
          <th
            colspan="14"
            style="font-weight: bold !important;font-family: Arial !important;color: white !important;font-weight: bold !important;font-size: 17px !important;"
          >
            CARRIER INFORMATION
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          style="font-family: Arial !important;height:18.3pt; -aw-height-rule:exactly"
        >
          <td
            colspan="5"
            style="font-weight: bold !important;font-family: Arial !important;width:38.35pt; border:0.75pt solid black; padding-right:13.92pt; padding-left:19.38pt; vertical-align:top; -aw-border:0.5pt single"
          >
            HANDLING UNIT
          </td>

          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.68pt; border:0.75pt solid black; padding-left:6.32pt; vertical-align:top; -aw-border:0.5pt single; -aw-padding-right:0.25pt"
          >
            H.M.X
          </td>

          <td
            style="font-family: Arial !important;width:19.68pt; border:0.75pt solid black; padding-left:6.32pt; vertical-align:top; -aw-border:0.5pt single; -aw-padding-right:0.25pt"
          ></td>
          <td
            colspan="5"
            rowspan="1"
            style="font-weight: bold !important;font-family: Arial !important;white-space: nowrap;width:199.05pt; border:0.75pt solid black; padding-right:5.58pt; padding-left:14.32pt; vertical-align:middle; -aw-border:0.5pt single"
          >
            COMMODITY DESCRIPTION
          </td>
          <td
            colspan="2"
            style="font-weight: bold !important;font-family: Arial !important;width:36.75pt; border:0.75pt solid black; padding-right:23.02pt; padding-left:28.98pt; vertical-align:top; -aw-border:0.5pt single"
          >
            LTL ONLY
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:18.3pt; -aw-height-rule:exactly"
        >
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.4pt; border:0.75pt solid black; padding-right:5.42pt; padding-left:9.98pt; vertical-align:top; -aw-border:0.5pt single"
          >
            QTY
          </td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.4pt; border:0.75pt solid black; padding-right:5.42pt; padding-left:9.98pt; vertical-align:top; -aw-border:0.5pt single"
          >
            TYPE
          </td>

          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.4pt; border:0.75pt solid black; padding-right:5.88pt; padding-left:10.42pt; vertical-align:top; -aw-border:0.5pt single"
          >
            QTY
          </td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.4pt; border:0.75pt solid black; padding-right:5.88pt; padding-left:10.42pt; vertical-align:top; -aw-border:0.5pt single"
          >
            TYPE
          </td>

          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.68pt; border:0.75pt solid black; padding-left:6.32pt; vertical-align:top; -aw-border:0.5pt single; -aw-padding-right:0.25pt"
          >
            WEIGHT
          </td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.68pt; border:0.75pt solid black; padding-left:6.32pt; vertical-align:top; -aw-border:0.5pt single; -aw-padding-right:0.25pt"
          >
            TOTAL QTY
          </td>

          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.68pt; border:0.75pt solid black; padding-left:6.32pt; vertical-align:top; -aw-border:0.5pt single; -aw-padding-right:0.25pt"
          >
            TOTAL WGT
          </td>
          <td
            colspan="5"
            style="font-family: Arial !important;width:199.05pt; border:0.75pt solid black; padding-right:5.58pt; padding-left:14.32pt; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:31.1pt; border:0.75pt solid black; padding-right:6.32pt; padding-left:11.32pt; vertical-align:top; -aw-border:0.5pt single"
          >
            NMFC#
          </td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:27.9pt; border:0.75pt solid black; padding-right:2.92pt; padding-left:8.43pt; vertical-align:top; -aw-border:0.5pt single"
          >
            CLASS
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:17.7pt; -aw-height-rule:exactly"
          *ngFor="let item of data.billoflading; let i=index"
        >
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              {{item.TotalPallet}}
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              {{item.type}}
            </p>
          </td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              {{item.Quantity}}
            </p>
          </td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
            PCS
            </p>
          </td>

          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{item.weight}}
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            {{item.Quantity*item.TotalPallet}}
          </td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            {{item.weight*item.TotalPallet}}
          </td>
          <td
            colspan="5"
            style="font-family: Arial !important;width:218.95pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
            *ngIf="poNumberView"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{item.ItemNumber}} / {{item.Description}} / PO#{{item.poNumber}}
            </p>
            <p
            *ngIf="!poNumberView"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{item.ItemNumber}} / {{item.Description}}
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:48.75pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{item.nmfc_product}}
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:39.25pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{item.class_product}}
            </p>
          </td>
        </tr>
        <tr
          *ngIf="tr1"
          style="font-family: Arial !important;height:17.7pt; -aw-height-rule:exactly"
        >
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            colspan="5"
            style="font-family: Arial !important;width:218.95pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:48.75pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:39.25pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
        </tr>
        <tr
          *ngIf="tr2"
          style="font-family: Arial !important;height:17.7pt; -aw-height-rule:exactly"
        >
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            colspan="5"
            style="font-family: Arial !important;width:218.95pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:48.75pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:39.25pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
        </tr>
        <tr
          *ngIf="tr3"
          style="font-family: Arial !important;height:17.7pt; -aw-height-rule:exactly"
        >
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            colspan="5"
            style="font-family: Arial !important;width:218.95pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:48.75pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:39.25pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
        </tr>
        <tr
          *ngIf="tr4"
          style="font-family: Arial !important;height:17.7pt; -aw-height-rule:exactly"
        >
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            colspan="5"
            style="font-family: Arial !important;width:218.95pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:48.75pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:39.25pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
        </tr>
        <tr
          *ngIf="tr5"
          style="font-family: Arial !important;height:17.7pt; -aw-height-rule:exactly"
        >
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          ></td>

          <td
            colspan="5"
            style="font-family: Arial !important;width:218.95pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:48.75pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:39.25pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
        </tr>

        <tr
          style="font-family: Arial !important;height:19.15pt; -aw-height-rule:exactly"
        >
          <td
            colspan="2"
            style="font-weight: bold !important;font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
          <p
             
          style="font-weight: bold !important;color: black !important;font-family: Arial !important;font-size:17px !important;"
        >
          <span style="font-family: Arial !important;-aw-import:ignore"
            >&#xa0;</span
          >
          {{data.items.length}} 
        </p>
           
          </td>

          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="false"
              style="font-family: Arial !important;font-size:17px !important;color: black !important;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{Quantity}}
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:26pt; border:0.75pt solid black; vertical-align:middle; background-color:white !important; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:26pt; border:0.75pt solid black; vertical-align:middle; background-color:white !important; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;font-size:17px !important;color: black !important;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:26pt; border:0.75pt solid black; vertical-align:middle; background-color:white !important; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:26pt; border:0.75pt solid black; vertical-align:middle; background-color:white !important; -aw-border:0.5pt single"
          >
            <p
             
              style="font-weight: bold !important;color: black !important;font-family: Arial !important;font-size:17px !important;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{sumaweight}}
            </p>
          </td>
          <td
            colspan="5"
            style="background-color: white  !important;font-weight: bold !important;font-family: Arial !important;width:218.95pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            GRAND TOTAL
          </td>
          <td
            style="font-family: Arial !important;width:48.75pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:39.25pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="tableW">
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          style="font-family: Arial !important;height:44.15pt; -aw-height-rule:exactly"
        >
          <td
            colspan="2"
            style="font-family: Arial !important;width:320.6pt; border:0.75pt solid black; padding-right:9.32pt; padding-left:4.42pt; vertical-align:top; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;text-align: justify;margin-top: 2.6pt;line-height: 7.2pt;"
            >
              <span
                style="font-family: Arial !important;font-family: Arial;font-size: 8pt;color: black;font-weight: bold;"
                >Where the rate is dependent on value, shippers are required to
                state specifically in writing the agreed or declared value of
                the property as follows: “The agreed or declared value of the
                property is specifically stated by the shipper to be not
                exeeding ____________ per ____________
              </span>
            </p>
          </td>
          <td
            colspan="3"
            style="font-family: Arial !important;width: 163.35pt;border: 0.75pt solid black;padding-right: 31.78pt;padding-left: 0em !important;vertical-align: middle;-aw-border: 0.5pt single;"
          >
            <p
              style="font-family: Arial !important;text-align:center; line-height:13pt"
            >
              <span
                style="font-family: Arial !important;font-family: Arial;font-size: 8pt;color: black;font-weight: bold;"
                >CODAmount: $________ Fee Terms: Collect Prepaid Customer check
                acceptable</span
              >
            </p>
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:15.9pt; -aw-height-rule:exactly"
        >
          <td
            colspan="5"
            style="font-family: Arial !important;width:459.35pt; border:0.75pt solid black; padding-right:74.53pt; padding-left:4.42pt; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;text-align: center;margin-top: 2.6pt;line-height: 7.2pt;"
            >
              <span
                style="font-family: Arial !important;font-family: Arial;font-size: 8pt;color: black;font-weight: bold;"
                >NOTE: Liability limitation for loss or damage in this shipment
                may be applicable. See 49 U.S.C. 14706(c)(1)(A) and (B)</span
              >
            </p>
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:30.85pt; -aw-height-rule:exactly"
        >
          <td
            colspan="2"
            style="font-family: Arial !important;width:311.85pt; border:0.75pt solid black; padding-right:16.92pt; padding-left:4.42pt; vertical-align:top; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;text-align: justify;margin-top: 2.6pt;line-height: 7.2pt;"
            >
              <span
                style="font-family: Arial !important;font-family: Arial;font-size: 8pt;color: black;font-weight: bold;"
                >RECEIVED, subject to individually determined rates or contracts
                that have been agreed upon in writing between the carrier and
                shipper, if applicable, otherwise to the rates, classifications
                and rules that have been establed by the carrier and are
                available to the shipper, on request, and to all applicable
                state and federal reguations.</span
              >
            </p>
          </td>
          <td
            colspan="3"
            style="font-family: Arial !important;width:199.6pt; border:0.75pt solid black; padding-right:0.38pt; padding-left:4.38pt; vertical-align:top; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;text-align: justify;margin-top: 2.6pt;line-height: 7.2pt;"
            >
              <span
                style="font-family: Arial !important;font-family: Arial;font-size: 8pt;color: black;font-weight: bold;"
                >The carrier shall not make delivery of this shipment without
                payment of freight and all other lawful charges.
                __________________________ Shipper Signature</span
              >
            </p>
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:73.4pt; -aw-height-rule:exactly"
        >
          <td
            style="font-family: Arial !important;width: 182.22pt;border: 0.75pt solid black;vertical-align: top;-aw-border: 0.5pt single;-aw-padding-right: 0.35pt;"
          >
            <p
              style="font-family: Arial !important;text-align: justify;margin-top: 2.6pt;/* line-height: 7.2pt; */font-size: 10px !important;font-weight: bold;color: black !important;"
            >
              <span
                style="font-family: Arial !important;font-family: Arial;font-size: 8pt;color: black;font-weight: bold;"
                >SHIPPER SIGNATURE / DATE
              </span>
              This is to certify that the above-named materials are properly
              classified, described, packaged, marked and labeled, and are in
              proper condition for transportation according to the applicable
              regulations of the Department of
              Transportation.____________________PER____________(Signature)
              (Date)
            </p>
          </td>
          <td
            colspan="2"
            style="font-family: Arial !important;width:159.2pt; border:0.75pt solid black; vertical-align:top; -aw-border:0.5pt single"
          >
            <tr>
              <th>
                <p
                  style="font-family: Arial !important;font-family: Arial;font-size: 10pt !important;color: black !important;text-align: justify;padding-left: 0em;white-space: nowrap;"
                >
                  Trailer Loaded: <br />
                  By Shipper:[] <br />
                  By Driver:[] <br />
                  Verify Load By:_______ <br />
                </p>
              </th>
              <th>
                <p
                  style="font-family: Arial !important;font-family: Arial;font-size: 10pt !important;color: black !important;text-align: justify;padding-left: 0em;white-space: nowrap;"
                >
                  Freight Counted: <br />
                  By Driver:[] <br />
                  pallets said to contain:[] <br />
                  By Driver/Pieces:[]
                </p>
              </th>
            </tr>
          </td>
          <td
            colspan="2"
            style="font-family: Arial !important;width:181.12pt; border:0.75pt solid black; vertical-align:top; -aw-border:0.5pt single"
          >
            <p
              style="font-family: Arial !important;text-align: justify;margin-top: 2.6pt;/* line-height: 7.2pt; */font-size: 10px !important;font-weight: bold;color: black !important;"
            >
              <span
                style="font-family: Arial !important;font-family: Arial;font-size: 8pt;color: black;font-weight: bold;"
                >CARRIER SIGNATURE/ PICKUP DATE
              </span>
              <br />
              Carrier acknowledges receipt of packages and required placards.
              Carrier certifies emergency response information was made
              available and/or carrier has the DOT emergency response guidebook
              or equivalent documentation in the vehicle.Property described
              above is received in good order, except as
              noted_____________________(Signature)_________________(Date)
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
    <br />
    <br />
  </div>
</div>
<div
  *ngIf="hoja2v"
  class="saltopagina"
  style="font-family: Arial !important;
margin: 0.6in;
"
>
  <div
    id="printableArea2"
    class="saltopagina"
    style="font-family: Arial !important;  display: block;   page-break-before: always;"
    #pdfTable2
  >
    <div
      *ngIf="false"
      class="printPageButton"
      style="font-family: Arial !important;-aw-headerfooter-type:header-primary; clear:both"
    >
      <ol
        start="2"
        type="I"
        style="font-family: Arial !important;margin:0pt; padding-left:0pt"
      >
        <li
          style="font-family: Arial !important;margin-left:14.45pt; text-align:justify; line-height:14.5pt; font-family:Arial; font-size:13pt"
        >
          <span
            style="font-family: Arial !important;font-weight:bold; color:black"
            >The Standard Bill of Lading Form</span
          >
        </li>
      </ol>
    </div>
    <p
      *ngIf="false"
      class="printPageButton"
      style="font-family: Arial !important;text-align:justify; line-height:10.05pt"
    >
      <span
        style="font-family: Arial !important;font-family:Arial; font-size:9pt; color:black"
        >GS1 US (VICS) Standard BOL:</span
      ><span
        style="font-family: Arial !important;font-family:Arial; font-size:9pt; color:black; -aw-import:spaces"
        >&#xa0; </span
      ><span
        style="font-family: Arial !important;font-family:Arial; font-size:9pt; color:black"
        >http://www.gs1us.org/, then click Logistics for complete BOL guideline
        information.</span
      >
    </p>
    <p
      *ngIf="false"
      class="printPageButton"
      style="font-family: Arial !important;margin-top:2.45pt; text-align:justify; font-size:1pt"
    >
      <span
        style="font-family: Arial !important;font-family:Arial; color:#ffffff; background-color:#ffffff; -aw-import:spaces"
        >&#xa0;</span
      >
    </p>
    <br />
    <table
      cellspacing="0"
      cellpadding="0"
      class="tableW"
      style="font-family: Arial !important;margin-left: 0.25pt;-aw-border-insideh: 0.5pt single #000000;-aw-border-insidev: 0.5pt single #000000;border-collapse: collapse;"
    >
      <tr
        style="font-family: Arial !important;height:43.5pt; -aw-height-rule:exactly"
      >
        <td
          colspan="18"
          style="font-family: Arial !important;width:531.6pt; border:0.75pt solid black; padding-right:1.83pt; padding-left:4.88pt; vertical-align:top; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;line-height:21.6pt">
            <span
              style="font-family: Arial !important;font-family: Arial;font-size: 17px !important;color: black;text-align: left !important;margin-right: 4em;"
              >Date: {{data.orderData.shipDate | date}}</span
            ><span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; font-weight:bold; letter-spacing:127.6pt; color:black"
            >
            </span>
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; font-weight:bold; color:black"
              >SUPPLEMENT TO THE BILL OF LADING:{{data.order}} </span
            ><span
              style="font-family: Arial !important;font-family:Arial; font-size:10pt; letter-spacing:74.75pt; color:black"
            >
            </span>
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:10pt; letter-spacing:74.75pt; color:black"
            >
            </span>
            <span
              style="font-family: Arial !important;font-family: Arial;font-size: 17px !important;color: black;text-align: right;margin-left: 7em;"
              >Page 2
            </span>
          </p>
        </td>
        <td style="font-family: Arial !important;vertical-align:top"></td>
      </tr>
      <tr
        style="font-family: Arial !important;height:30.3pt; -aw-height-rule:exactly"
      >
        <td
          colspan="13"
          style="font-family: Arial !important;width: 122.95pt;border: 0.75pt solid black;padding-right: 36.22pt;padding-left: 114.18pt !important;background-color: black;-aw-border: 0.5pt single;"
        >
          <p
            style="font-family: Arial !important;margin-top:0.65pt; text-align:center; line-height:7.8pt"
          >
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; font-weight:bold; color:#ffffff; background-color:black"
              >CUSTOMER ORDER INFORMATION</span
            >
          </p>
        </td>
        <td
          colspan="5"
          style="font-family: Arial !important;width:168.2pt; border:0.75pt solid black; vertical-align:middle; background-color:black; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span
              style="font-family: Arial !important;color:#ffffff; -aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td style="font-family: Arial !important;vertical-align:top"></td>
      </tr>
      <tr
        style="font-family: Arial !important;height:18.15pt; -aw-height-rule:exactly"
      >
        <td
          colspan="6"
          style="font-family: Arial !important;width:104.45pt; border:0.75pt solid black; padding-right:22.58pt; padding-left:26.32pt; vertical-align:top; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;margin-top:2.8pt; text-align:center; line-height:7.8pt;font-size: 17px !important;font-weight: bold !important;"
          >
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; color:black"
              >PLTS</span
            >
          </p>
        </td>
        <td
          colspan="3"
          style="font-family: Arial !important;width:30.25pt; border:0.75pt solid black; padding-right:21.58pt; padding-left:23.42pt; vertical-align:top; -aw-border:0.5pt single"
        >
          <p
            style="color: black !important;font-family: Arial !important;margin-top:2.05pt; margin-left:5.85pt; text-indent:-5.85pt; text-align:center; line-height:7.8pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'#'; -aw-list-number-styles:'bullet'; -aw-list-padding-sml:1.96pt"
          >
            <span style="font-family: Arial !important;-aw-import:ignore"
              ><span
                style="font-family: Arial !important;font-family:Arial; font-size:17px !important;font-weight: bold !important;"
                >QTY </span
              ><span
                style="font-family: Arial !important;width:1.96pt; font:7pt 'Times New Roman'; display:inline-block"
              >
              </span></span
            ><span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; color:black"
            ></span>
          </p>
        </td>
        <td
          colspan="2"
          style="font-family: Arial !important;width:33pt; border:0.75pt solid black; padding-right:16.27pt; padding-left:18.38pt; vertical-align:top; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;margin-top:2.1pt; text-align:center; line-height:7.8pt;font-size: 17px !important;font-weight: bold !important;"
          >
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; color:black"
              >WEIGHT</span
            >
          </p>
        </td>
        <td
          colspan="2"
          style="font-weight: bold !important;font-family: Arial !important;width:47.65pt; border:0.75pt solid black; padding-right:8.88pt; padding-left:14.28pt; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;text-align:center; line-height:7.9pt;font-size: 17px !important;;"
          >
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; color:black"
              >LTL ONLY</span
            ><br />
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:6pt; color:black;font-size:17px !important;"
            >
              NMFC#/CLASS</span
            >
          </p>
        </td>
        <td
          colspan="5"
          style="font-family: Arial !important;width:100.3pt; border:0.75pt solid black; padding-right:31.22pt; padding-left:36.67pt; vertical-align:top; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;margin-top:2.05pt; text-align:center; line-height:7.8pt"
          >
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; color:black;font-weight: bold !important;"
              >ADDITIONAL SHIPPER INFO.</span
            >
          </p>
        </td>
        <td
          style="font-family: Arial !important;border-top:0.75pt solid black; vertical-align:top; -aw-border-top:0.5pt single"
        ></td>
        <td style="font-family: Arial !important;vertical-align:top"></td>
      </tr>
      <tr
        style="font-family: Arial !important;height:18.3pt; -aw-height-rule:exactly"
        *ngFor="let item of hoja2"
      >
        <td
          colspan="6"
          style="font-family: Arial !important;width:153.35pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;font-size:17px !important;color: black !important;"
            *ngIf="item.Quantity!=0"
          >
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
            {{data.order}}
          </p>
        </td>
        <td
          colspan="3"
          style="font-family: Arial !important;width:75.25pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;font-size:17px !important;color: black !important;"
            *ngIf="item.Quantity!=0"
          >
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
            {{item.Quantity}}
          </p>
        </td>
        <td
          colspan="2"
          style="font-family: Arial !important;width:67.65pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;font-size:17px !important;color: black !important;"
            *ngIf="item.Quantity!=0"
          >
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
            {{onSearchWeight(item.id)}}
          </p>
        </td>
        <td
          style="font-family: Arial !important;width: 9.65pt;border: 0.75pt solid black;padding-right: 10.07pt;padding-left: 51.08pt !important;vertical-align: middle;-aw-border: 0.5pt single;"
        >
          <p
            style="font-family: Arial !important;text-align:justify; line-height:7.8pt"
          >
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
            ></span>
          </p>
        </td>
        <td
          style="font-family: Arial !important;width: 10.1pt;border: 0.75pt solid black;padding-right: 10.02pt;padding-left: 44.08pt !important;vertical-align: middle;-aw-border: 0.5pt single;"
        >
          <p
            style="font-family: Arial !important;text-align:justify; line-height:7.8pt"
          >
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
            ></span>
          </p>
        </td>
        <td
          colspan="5"
          style="font-family: Arial !important;width:168.2pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;color: black !important;" *ngIf="true">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
            {{item.ItemNumber}} / {{item.Description}}
          </p>
        </td>
        <td style="font-family: Arial !important;vertical-align:top"></td>
        <td style="font-family: Arial !important;vertical-align:top"></td>
      </tr>
      <tr
        style="font-family: Arial !important;height:17.7pt; -aw-height-rule:exactly"
      >
        <td
          colspan="6"
          style="font-family: Arial !important;width:153.35pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;font-weight: bold !important;color: black !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
            GRAND TOTAL {{data.items.length}} PLTS
          </p>
        </td>
        <td
          colspan="3"
          style="font-weight: bold !important;font-family: Arial !important;width:75.25pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;font-weight: bold !important;color: black !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
            {{Quantity}}
          </p>
        </td>
        <td
          colspan="2"
          style="font-weight: bold !important;font-family: Arial !important;width:67.65pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;font-weight: bold !important;color: black !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
            {{sumaweight}}
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:9.65pt; border:0.75pt solid black; padding-right:10.07pt; padding-left:15.08pt; vertical-align:top; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;margin-top:4.15pt; text-align:justify; line-height:7.8pt"
          >
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
            ></span>
          </p>
        </td>
        <td
          style="font-family: Arial !important;width:10.1pt; border:0.75pt solid black; padding-right:10.02pt; padding-left:15.12pt; vertical-align:top; -aw-border:0.5pt single"
        >
          <p
            style="font-family: Arial !important;margin-top:4.15pt; text-align:justify; line-height:7.8pt"
          >
            <span
              style="font-family: Arial !important;font-family:Arial; font-size:17px !important; letter-spacing:-107374182.4pt; color:black"
            ></span>
          </p>
        </td>
        <td
          colspan="5"
          style="font-family: Arial !important;width:168.2pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
          </p>
        </td>
        <td style="font-family: Arial !important;vertical-align:top"></td>
        <td style="font-family: Arial !important;vertical-align:top"></td>
      </tr>

      <tr style="font-family: Arial !important;height:0pt">
        <td style="font-family: Arial !important;width:35.55pt"></td>
        <td style="font-family: Arial !important;width:35.55pt"></td>
        <td style="font-family: Arial !important;width:36.45pt"></td>
        <td style="font-family: Arial !important;width:35.95pt"></td>
        <td style="font-family: Arial !important;width:0.05pt"></td>
        <td style="font-family: Arial !important;width:10.55pt"></td>
        <td style="font-family: Arial !important;width:49pt"></td>
        <td style="font-family: Arial !important;width:0.05pt"></td>
        <td style="font-family: Arial !important;width:26.95pt"></td>
        <td style="font-family: Arial !important;width:0.05pt"></td>
        <td style="font-family: Arial !important;width:68.35pt"></td>
        <td style="font-family: Arial !important;width:35.55pt"></td>
        <td style="font-family: Arial !important;width:36pt"></td>
        <td style="font-family: Arial !important;width:0.05pt"></td>
        <td style="font-family: Arial !important;width:79.45pt"></td>
        <td style="font-family: Arial !important;width:0.05pt"></td>
        <td style="font-family: Arial !important;width:49.45pt"></td>
        <td style="font-family: Arial !important;width:39.95pt"></td>
        <td style="font-family: Arial !important;width:0.05pt"></td>
        <td style="font-family: Arial !important;width:0.05pt"></td>
      </tr>
    </table>
    <p>
      <span style="font-family: Arial !important;-aw-import:ignore"
        >&#xa0;</span
      >
    </p>
    <br />
  </div>
</div>
<div *ngIf="true" class="saltopagina">
  <div
    class="saltopagina"
    id="printableArea3"
    style="font-family: Arial !important;  display: block;   page-break-before: always;"
    #pdfTable3
  >
    <div
      *ngIf="false"
      class="printPageButton"
      style="font-family: Arial !important;-aw-headerfooter-type:header-primary; clear:both"
    >
      <ol
        start="2"
        type="I"
        style="font-family: Arial !important;margin:0pt; padding-left:0pt"
      >
        <li
          style="font-family: Arial !important;margin-left:14.45pt; text-align:justify; line-height:14.5pt; font-family:Arial; font-size:13pt"
        >
          <span
            style="font-family: Arial !important;font-weight:bold; color:black"
            >The Standard Bill of Lading Form</span
          >
        </li>
      </ol>
    </div>
    <p
      *ngIf="false"
      class="printPageButton"
      style="font-family: Arial !important;text-align:justify; line-height:10.05pt"
    >
      <span
        style="font-family: Arial !important;font-family:Arial; font-size:9pt; color:black"
        >GS1 US (VICS) Standard BOL:</span
      ><span
        style="font-family: Arial !important;font-family:Arial; font-size:9pt; color:black; -aw-import:spaces"
        >&#xa0; </span
      ><span
        style="font-family: Arial !important;font-family:Arial; font-size:9pt; color:black"
        >http://www.gs1us.org/, then click Logistics for complete BOL guideline
        information.</span
      >
    </p>
    <p
      *ngIf="false"
      class="printPageButton"
      style="font-family: Arial !important;margin-top:2.45pt; text-align:justify; font-size:1pt"
    >
      <span
        style="font-family: Arial !important;font-family:Arial; color:#ffffff; background-color:#ffffff; -aw-import:spaces"
        >&#xa0;</span
      >
    </p>

    <table class="tableW">
      <thead>
        <tr
          style="font-family: Arial !important;height:43.5pt; -aw-height-rule:exactly"
        >
          <td
            colspan="14"
            style="font-family: Arial !important;width:531.6pt; border:0.75pt solid black; padding-right:1.83pt; padding-left:4.88pt; vertical-align:top; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;line-height:21.6pt">
              <span
                style="font-family: Arial !important;font-family: Arial;font-size: 17px !important;color: black;text-align: left !important;margin-right: 4em;"
                >Date: {{data.orderData.shipDate | date}}</span
              ><span
                style="font-family: Arial !important;font-family:Arial; font-size:17px !important; font-weight:bold; letter-spacing:127.6pt; color:black"
              >
              </span>
              <span
                style="font-family: Arial !important;font-family:Arial; font-size:17px !important; font-weight:bold; color:black"
                >SUPPLEMENT TO THE BILL OF LADING:{{data.order}} </span
              ><span
                style="font-family: Arial !important;font-family:Arial; font-size:10pt; letter-spacing:74.75pt; color:black"
              >
              </span>
              <span
                style="font-family: Arial !important;font-family:Arial; font-size:10pt; letter-spacing:74.75pt; color:black"
              >
              </span>
              <span
                style="font-family: Arial !important;font-family: Arial;font-size: 17px !important;color: black;text-align: right;margin-left: 7em;"
                >Page {{labelpaginar3}}
              </span>
            </p>
          </td>
          <td style="font-family: Arial !important;vertical-align:top"></td>
        </tr>
        <tr
          style="font-family: Arial !important;height:10.3pt; -aw-height-rule:exactly;background-color: #000000 !important;"
        >
          <th
            colspan="14"
            style="font-weight: bold !important;font-weight: bold !important;font-family: Arial !important;color: white !important;font-weight: bold !important;font-size: 17px !important;"
          >
            CARRIER INFORMATION
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          style="font-family: Arial !important;height:18.3pt; -aw-height-rule:exactly"
        >
          <td
            colspan="5"
            style="font-weight: bold !important;font-family: Arial !important;width:38.35pt; border:0.75pt solid black; padding-right:13.92pt; padding-left:19.38pt; vertical-align:top; -aw-border:0.5pt single"
          >
            HANDLING UNIT
          </td>

          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.68pt; border:0.75pt solid black; padding-left:6.32pt; vertical-align:top; -aw-border:0.5pt single; -aw-padding-right:0.25pt"
          >
            H.M.X
          </td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.68pt; border:0.75pt solid black; padding-left:6.32pt; vertical-align:top; -aw-border:0.5pt single; -aw-padding-right:0.25pt"
          ></td>
          <td
            colspan="5"
            rowspan="1"
            style="font-weight: bold !important;font-family: Arial !important;white-space: nowrap;width:199.05pt; border:0.75pt solid black; padding-right:5.58pt; padding-left:14.32pt; vertical-align:middle; -aw-border:0.5pt single"
          >
            COMMODITY DESCRIPTION
          </td>
          <td
            colspan="2"
            style="font-weight: bold !important;font-family: Arial !important;width:36.75pt; border:0.75pt solid black; padding-right:23.02pt; padding-left:28.98pt; vertical-align:top; -aw-border:0.5pt single"
          >
            LTL ONLY
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:18.3pt; -aw-height-rule:exactly"
        >
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.4pt; border:0.75pt solid black; padding-right:5.42pt; padding-left:9.98pt; vertical-align:top; -aw-border:0.5pt single"
          >
            QTY
          </td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.4pt; border:0.75pt solid black; padding-right:5.42pt; padding-left:9.98pt; vertical-align:top; -aw-border:0.5pt single"
          >
            TYPE
          </td>

          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.4pt; border:0.75pt solid black; padding-right:5.88pt; padding-left:10.42pt; vertical-align:top; -aw-border:0.5pt single"
          >
            QTY
          </td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.4pt; border:0.75pt solid black; padding-right:5.88pt; padding-left:10.42pt; vertical-align:top; -aw-border:0.5pt single"
          >
            TYPE
          </td>

          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.68pt; border:0.75pt solid black; padding-left:6.32pt; vertical-align:top; -aw-border:0.5pt single; -aw-padding-right:0.25pt"
          >
            WEIGHT
          </td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.68pt; border:0.75pt solid black; padding-left:6.32pt; vertical-align:top; -aw-border:0.5pt single; -aw-padding-right:0.25pt"
          >
            TOTAL QTY
          </td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:19.68pt; border:0.75pt solid black; padding-left:6.32pt; vertical-align:top; -aw-border:0.5pt single; -aw-padding-right:0.25pt"
          >
            TOTAL WGT
          </td>
          <td
            colspan="5"
            style="font-family: Arial !important;width:199.05pt; border:0.75pt solid black; padding-right:5.58pt; padding-left:14.32pt; vertical-align:middle; -aw-border:0.5pt single"
          ></td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:31.1pt; border:0.75pt solid black; padding-right:6.32pt; padding-left:11.32pt; vertical-align:top; -aw-border:0.5pt single"
          >
            NMFC#
          </td>
          <td
            style="font-weight: bold !important;font-family: Arial !important;width:27.9pt; border:0.75pt solid black; padding-right:2.92pt; padding-left:8.43pt; vertical-align:top; -aw-border:0.5pt single"
          >
            CLASS
          </td>
        </tr>
        <tr
          style="font-family: Arial !important;height:17.7pt; -aw-height-rule:exactly"
          *ngFor="let item of arrrayHoja4; let i=index"
        >
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="item.TotalPallet!=0"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              {{item.TotalPallet}}
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="item.TotalPallet!=0"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              {{item.type}}
            </p>
          </td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="item.TotalPallet!=0"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              {{item.Quantity}}
            </p>
          </td>

          <td
            style="font-family: Arial !important;width:35.7pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="item.TotalPallet!=0"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              PCS
            </p>
          </td>

          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="item.TotalPallet!=0"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{item.weight}}
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="item.TotalPallet!=0"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{item.Quantity*item.TotalPallet}}
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="item.TotalPallet!=0"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{item.weight*item.TotalPallet}}
            </p>
          </td>
          <td
            colspan="5"
            style="font-family: Arial !important;width:218.95pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="item.TotalPallet!=0"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{item.ItemNumber}} / {{item.Description}}
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:48.75pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="item.TotalPallet!=0"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{item.nmfc_product}}
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:39.25pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="item.TotalPallet!=0"
              style="font-family: Arial !important;font-size: 17px !important;color: black !important;white-space: nowrap;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{item.class_product}}
            </p>
          </td>
        </tr>

        <tr
          style="font-family: Arial !important;height:19.15pt; -aw-height-rule:exactly"
        >
          <td
            colspan="5"
            style="font-family: Arial !important;width:34.8pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
          <p
             
              style="font-family: Arial !important;font-size:17px !important;color: black !important;font-weight: bold !important;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              GRAND TOTAL {{data.items.length}} PLTS
            </p>
         
          </td>

          <td
            style="font-family: Arial !important;width:58.85pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p
              *ngIf="false"
              style="font-family: Arial !important;font-size:17px !important;color: black !important; font-weight: bold !important;"
            >
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
              {{Quantity}}
            </p>
          </td>
         
     
          <td
          style="font-family: Arial !important;width:26pt; border:0.75pt solid black; vertical-align:middle; background-color:white !important; -aw-border:0.5pt single"
        >
          <p style="font-family: Arial !important;font-size:17px !important;font-weight: bold !important;color: black !important;">
            <span style="font-family: Arial !important;-aw-import:ignore"
              >&#xa0;</span
            >
            {{sumaweight}}
          </p>
        </td>
          <td
            colspan="5"
            style="background-color: white  !important;font-weight: bold !important;font-family: Arial !important;width:218.95pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >

          </td>
          <td
            style="font-family: Arial !important;width:48.75pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
          <td
            style="font-family: Arial !important;width:39.25pt; border:0.75pt solid black; vertical-align:middle; -aw-border:0.5pt single"
          >
            <p style="font-family: Arial !important;font-size:17px !important;">
              <span style="font-family: Arial !important;-aw-import:ignore"
                >&#xa0;</span
              >
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
    <p>
      <span style="font-family: Arial !important;-aw-import:ignore"
        >&#xa0;</span
      >
    </p>
    <br />
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
>
</ngx-spinner>
